import PageContainerBlank from '../components/PageContainer/PageContainerBlank';
import PageEndBlank from '../components/PageContainer/PageEndBlank';

const Tools = () => {
	return (
		<div>
			<PageContainerBlank />

			<h1>Tools</h1>
			<p className="justify"><span className="tab"></span>This is meant to be a collection of useful tools for the community. Two tools exist at present, but more tools will be added in the future (including at request).</p>

			<div className="img-church-container">
				<div className="img-church-fade"></div>
				<img src="/static/images/StJosephBuilding.webp" alt="St. Joseph Building" className="img-church" />
			</div>
			<h3>Also check out the <a href="https://stjosephparishhanover.org/" target="_blank" rel="noreferrer">St. Joseph Parish website</a>!</h3>

			<PageEndBlank />
		</div>
	);
};

export default Tools;